/** 站点/区域名 → [经度, 纬度]，用于设备未填坐标时在地图上近似落点 */
const CITY_COORDS = [
  { keys: ['徐汇'], coord: [121.436, 31.188] },
  { keys: ['浦东', '浦东新区'], coord: [121.544, 31.221] },
  { keys: ['闵行'], coord: [121.381, 31.113] },
  { keys: ['宝山'], coord: [121.489, 31.405] },
  { keys: ['嘉定'], coord: [121.265, 31.375] },
  { keys: ['松江'], coord: [121.228, 31.032] },
  { keys: ['青浦'], coord: [121.124, 31.151] },
  { keys: ['奉贤'], coord: [121.474, 30.918] },
  { keys: ['金山'], coord: [121.341, 30.741] },
  { keys: ['崇明'], coord: [121.397, 31.623] },
  { keys: ['黄浦', '静安', '长宁', '普陀', '虹口', '杨浦'], coord: [121.473, 31.230] },
  { keys: ['上海'], coord: [121.473, 31.230] },
  { keys: ['北京'], coord: [116.407, 39.904] },
  { keys: ['广州'], coord: [113.264, 23.129] },
  { keys: ['深圳'], coord: [114.057, 22.543] },
  { keys: ['杭州'], coord: [120.155, 30.274] },
  { keys: ['南京'], coord: [118.796, 32.060] },
  { keys: ['苏州'], coord: [120.585, 31.299] },
  { keys: ['成都'], coord: [104.066, 30.572] },
  { keys: ['武汉'], coord: [114.305, 30.593] },
  { keys: ['西安'], coord: [108.939, 34.341] },
  { keys: ['重庆'], coord: [106.551, 29.563] }
]

const DEFAULT_COORD = [121.473, 31.23]

export function hasPreciseCoord(device) {
  const lng = device.longitude != null ? Number(device.longitude) : NaN
  const lat = device.latitude != null ? Number(device.latitude) : NaN
  return !Number.isNaN(lng) && !Number.isNaN(lat)
}

export function resolveDeviceCoord(device) {
  const lng = device.longitude != null ? Number(device.longitude) : NaN
  const lat = device.latitude != null ? Number(device.latitude) : NaN
  if (!Number.isNaN(lng) && !Number.isNaN(lat)) {
    return [lng, lat]
  }
  const text = `${device.siteName || ''}${device.deviceName || ''}`
  for (const row of CITY_COORDS) {
    if (row.keys.some(k => text.includes(k))) {
      const jitter = hashJitter(device.deviceId || device.deviceCode || text)
      return [row.coord[0] + jitter[0], row.coord[1] + jitter[1]]
    }
  }
  const jitter = hashJitter(device.deviceId || device.deviceCode || text)
  return [DEFAULT_COORD[0] + jitter[0], DEFAULT_COORD[1] + jitter[1]]
}

function hashJitter(seed) {
  const s = String(seed)
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  const a = ((h & 0xff) / 255 - 0.5) * 0.35
  const b = (((h >> 8) & 0xff) / 255 - 0.5) * 0.25
  return [a, b]
}

export function regionLabel(siteName) {
  if (!siteName) return '—'
  const m = siteName.match(/([\u4e00-\u9fa5]{2,4}(?:区|县|市))/)
  return m ? m[1] : siteName
}
